import React, { useState, useEffect } from "react";
import { Box, Grid, ListItemText, Typography } from "@material-ui/core";
import translate from "../i18n/Translator";
import NumberFormat from "react-number-format";
import { PurchaseOrder } from "../model/PurchaseOrder";
import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis } from "recharts";
import { DataAmount } from "../budgets/BudgetPerformanceAmounts";


interface PurchaseOrderInvoicedAmountProps {
    purchaseOrder: PurchaseOrder
}

export function PurchaseOrderInvoicedAmount(props: PurchaseOrderInvoicedAmountProps) {
    const [invoicedDiscount, setInvoicedDiscount] = useState<number>(props.purchaseOrder.lines.flatMap(line => line.cfdis ? line.cfdis : []).flatMap(cfdi => cfdi.concepts ? cfdi.concepts : []).map(concept => concept ? concept.discount ? concept.discount : 0 : 0).reduce((a, b) => a + b))
    const [invoicedAmount, setInvoicedAmount] = useState<number>(props.purchaseOrder.lines.flatMap(line => line.cfdis ? line.cfdis : []).flatMap(cfdi => cfdi.concepts ? cfdi.concepts : []).map(concept => concept ? concept.total_amount : 0).reduce((a,b ) => a + b) - invoicedDiscount);
    const [amountToInvoice, setAmountToInvoice] = useState<number>(props.purchaseOrder.total - invoicedAmount);

    const data = [{
        invoiced_amount: invoicedAmount, amount_to_invoice : amountToInvoice, total_purchase_order: props.purchaseOrder.total
    }];

    return (
        <Grid container xs={12} style={{ padding: "10px" }} spacing={2}>
            <Grid item xs={12} >
                <Typography style={{fontWeight: "bolder"}}>{translate("purchase_orders.invoiced_amount.subtitle" as string)}</Typography>
            </Grid>
            <Grid item xs={12}>
                <ResponsiveContainer width="100%" height={80}>
                    <BarChart data={data} layout="vertical">
                        <XAxis type="number" tick={false} tickLine={false} axisLine={false} />
                        <YAxis tick={false} tickLine={false} axisLine={false} dataKey="name" yAxisId="back" hide scale="band" type="category"/>
                        <YAxis tick={false} tickLine={false} axisLine={false} dataKey="name" yAxisId="target" hide scale="band" type="category"/>
                        <YAxis tick={false} tickLine={false} axisLine={false} dataKey="name" scale="band" type="category"/>
                        
                        <Bar 
                            className="monotone"
                            dataKey="total_purchase_order"
                            fill={"#FDE4D3"}
                            barSize={40}
                            radius={5}
                            yAxisId="back"
                             />
                        <Bar 
                            className="monotone"
                            dataKey="invoiced_amount"
                            fill={"#ffcc50"}
                            barSize={20}
                            stackId="a"
                             />
                        <Bar 
                            className="monotone"
                            dataKey="amount_to_invoice"
                            fill={"#F69450"}
                            barSize={20}
                            stackId="a"
                             />
                    </BarChart>
                </ResponsiveContainer>    
            </Grid>
            <Grid item xs={12}>
                <Grid container alignItems="center" wrap="nowrap" justifyContent="space-evenly" direction="row" spacing={1}>
                    <DataAmount amount={props.purchaseOrder.total || 0} title={translate("purchase_orders.invoiced_amount.total_amount") as string} color="#FDE4D3" shape="circle" icon={true} />
                    <DataAmount amount={invoicedAmount || 0} title={translate("purchase_orders.invoiced_amount.invoiced_amount") as string} color="#ffcc50" shape="circle" icon={true} />
                    <DataAmount amount={amountToInvoice || 0} title={translate("purchase_orders.invoiced_amount.amount_to_invoice") as string} color="#F69450" shape="circle" icon={true} />
                </Grid>
            </Grid>
        </Grid>
    );
}